<template>
	<appBaseModal v-if="shouldShowModal">	
		<div slot="content">
			<div class="modal__head--white">
				<img src="@/assets/images/icon__welcome.svg" alt="">
				<div class="modal__head__title">{{maContent.ma2_1_2}}</div>
				<div class="modal__head__subtitle">{{maContent.ma2_1_3}}</div>
			</div>
			<div class="modal__content" style="min-width:500px;">
				<div class="col md-4 welcome--001">
					<img src="@/assets/images/welcome--001.svg" alt="">
					<p>{{maContent.ma2_2_2}}</p>
				</div>
				<div class="col md-4 welcome--002">
					<img src="@/assets/images/welcome--002.svg" alt="">
					<p>{{maContent.ma2_3_2}}</p>
				</div>
				<div class="col md-4 welcome--003">
					<img src="@/assets/images/welcome--003.svg" alt="">
					<p>{{maContent.ma2_4_2}}</p>
				</div>
				<button class="welcome__close primary" @click="closeModaler">{{maContent.ma2_5}}</button></br>
				<a v-bind:href="maContent.ma2_6_2" target="_self"> <button v-if="maContent.maO_1 == true" class="welcome__close goto-sales">{{maContent.ma2_6_1}}</button></a>
			</div>
		</div>
	</appBaseModal>
</template>

<script>
    import BaseModal from './BaseModal';
	export default {
		components : {
			appBaseModal : BaseModal
		},
		data(){
			return {
				compName : 'WelcomeModal',
			}
		},
		
		methods : {
			closeModaler(){
				return this.$store.commit('closeModal', '');
			}
		},
		computed : {
			shouldShowModal(){
				return this.$store.getters.getModalActive.modalName === this.compName
			},
			maContent(){
      			return this.$store.getters.getBuildData;
    		},	
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/common/Modals/WelcomeModal.vue